<template>
  <div class="field no-select">
    <label
      v-if="label"
      class="mb-2 label no-select"
    >
      <h3>{{ label }}</h3>
    </label>
    <p
      v-if="hasHelpText"
      class="help-text"
      v-html="finalHelpText"
    ></p>
    <div class="container-archive">
      <span class="container-archive__name">
        {{ archiveName }}
      </span>
    </div>
    <button
      class="btn btn-secondary btn-icon"
      :disabled="isDisabled"
      @click="openUploader"
    >
      <IconPlus size="xs" />
      <span>Alterar arquivo</span>
    </button>
  </div>
</template>

<script>
import IconPlus from '@/components/icons/IconPlus.vue';

import { Crop, Local, pt, Uppload, xhrUploader } from 'uppload';

import getToken from '@/helpers/getToken';
import commonProperties from './common-properties';

export default {
  name: 'File',
  components: {
    IconPlus,
  },
  mixins: [commonProperties],
  inheritAttrs: false,
  props: {
    maxFileSize: {
      type: Number,
      default: 1,
    },
    mimeTypes: {
      type: Array,
      default() {
        return [
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'image/jpeg',
          'image/png',
        ];
      },
    },
  },
  data() {
    return {
      uploader: null,
      thumbSize: 100,
    };
  },
  computed: {
    hasArchive() {
      return typeof this.model === 'string' && this.model !== '';
    },
    archiveName() {
      return this.hasArchive
        ? this.model.split('/').reverse()[0]
        : 'Nenhum arquivo...';
    },
    endpoint() {
      const baseUrl =
        process.env.VUE_APP_API_BASE_URL ||
        'https://api.siteletsbook.com.br/v2/';

      return `${baseUrl}storage`;
    },
  },
  created() {
    this.uploader = new Uppload({
      lang: pt,
      uploader: xhrUploader({
        endpoint: this.endpoint,
        fileKeyName: 'file',
        settingsFunction(xmlHttp) {
          xmlHttp.setRequestHeader('Authorization', getToken());
        },
      }),
    });

    this.uploader.updateSettings({
      maxHeight: this.maxHeight,
      maxWidth: this.maxWidth,
    });

    this.uploader.use(
      new Local({
        maxFileSize: this.maxFileSize * 1024 * 1024,
        mimeTypes: this.mimeTypes,
      }),
    );

    if (this.maxWidth && this.maxHeight && !this.resizeInsteadCrop) {
      this.uploader.use(
        new Crop({
          aspectRatio: this.maxWidth / this.maxHeight,
        }),
      );
    }

    this.uploader.on('upload', (url) => {
      this.model = url;
    });
  },
  methods: {
    openUploader() {
      const lang = {
        ...pt,
        errors: {
          ...pt.errors,
          file_too_large: `Seu arquivo deve ter até ${this.maxFileSize} MB`,
        },
      };

      /**
       * We are setting i18n just before opening because Uppload translations
       * are global. We have a custom error message with a hardcoded value
       * (max file size in MB), otherwise a second ImageFile interface would
       * overwrite the first one translations and so on.
       */
      this.uploader.updateSettings({ lang });
      this.uploader.open();
    },
  },
};
</script>

<style lang="scss">
@import '~uppload/src/styles/uppload.scss';
@import '~uppload/src/themes/light.scss';
</style>

<style scoped lang="scss">
h3 {
  font-weight: $lb-medium;
  font-size: $size-normal;
  line-height: 1.5;
  color: $dark;
}

img {
  height: 100%;
}

button {
  width: 100%;
  margin-top: 16px;
  padding-right: 30px;

  span {
    flex-grow: 1;
  }
}

.container-archive {
  margin-top: 16px;

  &__name {
    font-size: $size-small;
    font-weight: $lb-bold;
  }
}
</style>
